import React from 'react';
import UserLayout from '../components/UserLayout';
import AffiliateCommunicationTracker from '../components/AffiliateCommunicationTracker';

const AffiliateCommunicationPage = () => {
  return (
    <UserLayout>
      <AffiliateCommunicationTracker />
    </UserLayout>
  );
};

export default AffiliateCommunicationPage; 